import { Link, Stack, Typography, useTheme } from "@mui/material";
import ApartmentIcon from "@mui/icons-material/Apartment";
import EmailIcon from "@mui/icons-material/Email";
import PaymentIcon from "@mui/icons-material/Payment";
import { useInformationPageCompanyInformationSectionT } from "src/translation-hooks/information-page-company-information-section";
import { useGetCustomerDetails } from "src/hooks";
import { hasValueAndNotEmpty } from "@itk/typescript-utils";
import { usePaymentTermsTranslation } from "src/translations-enums-hooks/usePaymentTermsTranslation";
import { useCurrencyTranslation } from "src/translations-enums-hooks/useCurrencyTranslation";
import { CircularProgress } from "@mui/material";
import { DekoxIcon } from "src/components";

export const CompanyInformation = () => {
  const informationPageCompanyInformationSectionT = useInformationPageCompanyInformationSectionT();
  const theme = useTheme();
  const { getPaymentTermsTranslation } = usePaymentTermsTranslation();
  const { getCurrencyTranslation } = useCurrencyTranslation();
  const { customerDetails } = useGetCustomerDetails();

  return (
    <Stack>
      {hasValueAndNotEmpty(customerDetails) ? (
        <Stack spacing={3} flex={1} paddingY={2} color={theme.palette.customColors.darkGrey}>
          <Stack direction="row" justifyContent="space-between">
            <Stack direction="row" spacing={2}>
              <ApartmentIcon fontSize="medium" />
              <Stack gap={1}>
                <Typography variant="body2" fontWeight={theme.typography.fontWeightBold}>
                  {informationPageCompanyInformationSectionT.company}
                </Typography>
                <Typography variant="subtitle1">
                  {informationPageCompanyInformationSectionT.name}: {customerDetails?.name}
                </Typography>
                <Typography variant="subtitle1">
                  {informationPageCompanyInformationSectionT.cvr}: {customerDetails?.vatNumber}
                </Typography>
              </Stack>
            </Stack>
          </Stack>

          {
            //i keep this below state because in future if we can get details from API then we need this
            /* <Stack direction="row" spacing={2} alignItems="flex-start" color={theme.palette.customColors.darkGrey}>
        <ExploreIcon fontSize="medium" />
        <Stack gap={1}>
          <Typography fontWeight={theme.typography.fontWeightBold}>{informationPageCompanyInformationSectionT.address}</Typography>
          <Typography variant="subtitle1">
            {informationPageCompanyInformationSectionT.streetName}: {companyData.address.street}
          </Typography>
          <Typography variant="subtitle1">
            {informationPageCompanyInformationSectionT.city}: {companyData.address.city}
          </Typography>
          <Typography variant="subtitle1">
            {informationPageCompanyInformationSectionT.postCode}: {companyData.address.postalCode}
          </Typography>
          <Typography variant="subtitle1">
            {informationPageCompanyInformationSectionT.country}: {companyData.address.country}
          </Typography>
        </Stack>
      </Stack> */
          }

          {(customerDetails?.email || customerDetails?.phoneNo) && (
            <Stack direction="row" spacing={2} alignItems="flex-start" color={theme.palette.customColors.darkGrey}>
              <EmailIcon fontSize="medium" />
              <Stack gap={1}>
                <Typography fontWeight={theme.typography.fontWeightBold}>{informationPageCompanyInformationSectionT.editInformation}</Typography>
                {customerDetails?.email && (
                  <Link href={`mailto:${customerDetails.email}`} underline="none" target="_blank">
                    <Typography display="flex" gap={1} alignItems="center" variant="subtitle1">
                      <DekoxIcon fontSize="small" icon="mail" /> {customerDetails?.email}
                    </Typography>
                  </Link>
                )}
                {customerDetails?.phoneNo && (
                  <Link href={`tel:${customerDetails.phoneNo}`} underline="none" target="_blank">
                    <Typography display="flex" gap={1} alignItems="center" variant="subtitle1">
                      <DekoxIcon fontSize="small" icon="call" /> {customerDetails?.phoneNo}
                    </Typography>
                  </Link>
                )}
              </Stack>
            </Stack>
          )}

          {(customerDetails?.customerPaymentTerm?.description || customerDetails?.currencyId) && (
            <Stack direction="row" spacing={2} alignItems="flex-start" color={theme.palette.customColors.darkGrey}>
              <PaymentIcon fontSize="medium" />
              <Stack gap={1}>
                <Typography fontWeight={theme.typography.fontWeightBold}>{informationPageCompanyInformationSectionT.paymentTerms}</Typography>
                {customerDetails?.customerPaymentTerm?.description && (
                  <Typography display="flex" gap={1} alignItems="center" variant="subtitle1">
                    {informationPageCompanyInformationSectionT.paymentTerms}: &nbsp;
                    {customerDetails?.customerPaymentTerm?.description ? getPaymentTermsTranslation(customerDetails.customerPaymentTerm.description) : undefined}
                  </Typography>
                )}
                {customerDetails?.currencyId && (
                  <Typography variant="subtitle1">
                    {informationPageCompanyInformationSectionT.currency}: {customerDetails?.currencyId ? getCurrencyTranslation(customerDetails.currencyId) : undefined}
                  </Typography>
                )}
              </Stack>
            </Stack>
          )}
        </Stack>
      ) : (
        <Stack alignItems="center" justifyContent="center" flex={1} paddingY={4}>
          <CircularProgress />
        </Stack>
      )}
    </Stack>
  );
};
